module.exports = __webpack_public_path__ + "static/media/BitKeep.ee125b09.png";